var React = require('react');

function SendMessage (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_13748_82)","key":0},React.createElement("path",{"d":"M0 7L14.03 8L0 9L0.0100021 16L16.03 8L0.0100021 0L0 7Z","fill":"#B7F2EA"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_13748_82"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

SendMessage.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SendMessage;

SendMessage.default = SendMessage;
